import React, { useEffect, useState, Component } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { PackageIcon, ArrowRightIcon, CheckIcon, XIcon, TrendingUpIcon, BoxesIcon } from 'lucide-react';
export const ProductBundlesPage = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-4484">
      <Navbar scrolled={scrolled} data-id="element-4485" />
      <main className="pt-24 pb-20" data-id="element-4486">
        <div className="container mx-auto px-4 md:px-6" data-id="element-4487">
          <div className="max-w-4xl mx-auto" data-id="element-4488">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 md:p-12 mb-12 text-white relative overflow-hidden" data-id="element-4489">
              <div className="absolute right-0 bottom-0 opacity-10" data-id="element-4490">
                <BoxesIcon className="h-64 w-64" data-id="element-4491" />
              </div>
              <div className="relative z-10" data-id="element-4492">
                <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-4493">
                  Product Bundles That Sell
                </h1>
                <p className="text-xl opacity-90 max-w-3xl" data-id="element-4494">
                  Discover how to create irresistible product bundles that
                  increase your average order value and provide more value to
                  your customers.
                </p>
              </div>
            </div>
            {/* Main content */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 md:p-10 shadow-sm mb-10" data-id="element-4495">
              <h2 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-6" data-id="element-4496">
                The Power of Product Bundling
              </h2>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6" data-id="element-4497">
                Product bundling is a proven strategy that can significantly
                boost your revenue and provide more value to your customers. By
                combining complementary digital products into a single package,
                you can increase your average order value while giving customers
                a better deal than if they purchased items separately.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6" data-id="element-4498">
                Studies show that well-designed bundles can increase revenue by
                15-30% compared to selling products individually, while also
                improving customer satisfaction through the perception of
                getting more value.
              </p>
              <div className="border-l-4 border-[#2DB489] dark:border-[#4ED1A0] pl-6 my-8 py-2" data-id="element-4499">
                <p className="text-lg font-medium text-gray-800 dark:text-[#F8FAF9] italic" data-id="element-4500">
                  "The key to successful bundling isn't just combining
                  products—it's creating packages that solve broader problems
                  for specific customer segments."
                </p>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mt-12 mb-6" data-id="element-4501">
                Types of Effective Digital Product Bundles
              </h2>
              <div className="mb-8" data-id="element-4502">
                <h3 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-4 flex items-center" data-id="element-4503">
                  <span className="bg-[#2DB489] dark:bg-[#4ED1A0] text-white w-8 h-8 rounded-full flex items-center justify-center mr-3" data-id="element-4504">
                    1
                  </span>
                  Complementary Product Bundles
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD] mb-4 ml-11" data-id="element-4505">
                  Combine products that work well together to solve a larger
                  problem or create a complete solution.
                </p>
                <div className="ml-11 bg-gray-50 dark:bg-[#1A3330] p-5 rounded-lg mb-6" data-id="element-4506">
                  <p className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-3" data-id="element-4507">
                    Example:
                  </p>
                  <div className="flex flex-col md:flex-row gap-4" data-id="element-4508">
                    <div className="flex-1 bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-4509">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-4510">
                        Website Template Bundle
                      </p>
                      <ul className="text-sm text-gray-600 dark:text-[#B0C1BD] space-y-1" data-id="element-4511">
                        <li data-id="element-4512">• Main website template</li>
                        <li data-id="element-4513">• Matching email newsletter template</li>
                        <li data-id="element-4514">• Social media graphics pack</li>
                        <li data-id="element-4515">• Brand style guide template</li>
                      </ul>
                      <p className="mt-3 text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-4516">
                        Complete brand presence across multiple channels
                      </p>
                    </div>
                    <div className="flex-1 bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-4517">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-4518">
                        Notion Productivity Bundle
                      </p>
                      <ul className="text-sm text-gray-600 dark:text-[#B0C1BD] space-y-1" data-id="element-4519">
                        <li data-id="element-4520">• Project management system</li>
                        <li data-id="element-4521">• Client CRM template</li>
                        <li data-id="element-4522">• Invoice tracker</li>
                        <li data-id="element-4523">• Content calendar</li>
                      </ul>
                      <p className="mt-3 text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-4524">
                        Complete business management system in one package
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8" data-id="element-4525">
                <h3 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-4 flex items-center" data-id="element-4526">
                  <span className="bg-[#2DB489] dark:bg-[#4ED1A0] text-white w-8 h-8 rounded-full flex items-center justify-center mr-3" data-id="element-4527">
                    2
                  </span>
                  Tiered Bundles
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD] mb-4 ml-11" data-id="element-4528">
                  Offer different bundle sizes (small, medium, large) with
                  increasing value at each tier to appeal to different customer
                  segments.
                </p>
                <div className="ml-11 bg-gray-50 dark:bg-[#1A3330] p-5 rounded-lg mb-6" data-id="element-4529">
                  <p className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-3" data-id="element-4530">
                    Example: UI Component Library
                  </p>
                  <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-4531">
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-4532">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-4533">
                        Starter Pack
                      </p>
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-4534">
                        50 essential components
                      </p>
                      <p className="text-sm font-medium text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-4535">
                        $39
                      </p>
                    </div>
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg border-2 border-[#2DB489] dark:border-[#4ED1A0]" data-id="element-4536">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-4537">
                        Pro Pack
                      </p>
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-4538">
                        150 components + design system
                      </p>
                      <p className="text-sm font-medium text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-4539">
                        $79
                      </p>
                      <p className="text-xs text-gray-500 dark:text-[#7A8F8A] mt-2" data-id="element-4540">
                        Most popular
                      </p>
                    </div>
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-4541">
                      <p className="font-medium text-gray-700 dark:text-[#C4D1CC] mb-2" data-id="element-4542">
                        Enterprise Pack
                      </p>
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-4543">
                        300+ components + source files
                      </p>
                      <p className="text-sm font-medium text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-4544">
                        $129
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="mb-8" data-id="element-4545">
                <h3 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-4 flex items-center" data-id="element-4546">
                  <span className="bg-[#2DB489] dark:bg-[#4ED1A0] text-white w-8 h-8 rounded-full flex items-center justify-center mr-3" data-id="element-4547">
                    3
                  </span>
                  Cross-Category Bundles
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD] mb-4 ml-11" data-id="element-4548">
                  Combine products from different categories that appeal to the
                  same target audience to increase exposure for your less
                  popular products.
                </p>
                <div className="ml-11 bg-gray-50 dark:bg-[#1A3330] p-5 rounded-lg mb-6" data-id="element-4549">
                  <p className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-3" data-id="element-4550">
                    Example: Creator Bundle
                  </p>
                  <ul className="text-sm text-gray-600 dark:text-[#B0C1BD] space-y-3" data-id="element-4551">
                    <li className="flex items-start" data-id="element-4552">
                      <span className="bg-blue-100 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 w-6 h-6 rounded-full flex items-center justify-center mr-2 flex-shrink-0" data-id="element-4553">
                        1
                      </span>
                      <div data-id="element-4554">
                        <p className="font-medium text-gray-700 dark:text-[#C4D1CC]" data-id="element-4555">
                          YouTube Thumbnail Templates
                        </p>
                        <p className="text-gray-500 dark:text-[#7A8F8A]" data-id="element-4556">
                          For video creators
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-4557">
                      <span className="bg-purple-100 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 w-6 h-6 rounded-full flex items-center justify-center mr-2 flex-shrink-0" data-id="element-4558">
                        2
                      </span>
                      <div data-id="element-4559">
                        <p className="font-medium text-gray-700 dark:text-[#C4D1CC]" data-id="element-4560">
                          Content Calendar System
                        </p>
                        <p className="text-gray-500 dark:text-[#7A8F8A]" data-id="element-4561">
                          For planning content
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-4562">
                      <span className="bg-green-100 dark:bg-green-900/30 text-green-600 dark:text-green-400 w-6 h-6 rounded-full flex items-center justify-center mr-2 flex-shrink-0" data-id="element-4563">
                        3
                      </span>
                      <div data-id="element-4564">
                        <p className="font-medium text-gray-700 dark:text-[#C4D1CC]" data-id="element-4565">
                          Social Media Caption Templates
                        </p>
                        <p className="text-gray-500 dark:text-[#7A8F8A]" data-id="element-4566">
                          For promoting content
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <h2 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mt-12 mb-6" data-id="element-4567">
                Pricing Strategies for Bundles
              </h2>
              <div className="bg-gray-50 dark:bg-[#1A3330] p-6 rounded-xl mb-8" data-id="element-4568">
                <h3 className="text-xl font-semibold text-gray-800 dark:text-[#F8FAF9] mb-4" data-id="element-4569">
                  Finding the Right Discount Level
                </h3>
                <p className="text-gray-600 dark:text-[#B0C1BD] mb-6" data-id="element-4570">
                  The discount you offer on bundles needs to be significant
                  enough to motivate purchase but not so large that it devalues
                  your products or cuts too deeply into your margins.
                </p>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6" data-id="element-4571">
                  <div className="bg-white dark:bg-[#162825] p-5 rounded-lg" data-id="element-4572">
                    <h4 className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-4573">
                      Too Small
                    </h4>
                    <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-4574">
                      5-10% discount
                    </p>
                    <div className="flex items-start" data-id="element-4575">
                      <XIcon className="h-5 w-5 text-red-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-4576" />
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD]" data-id="element-4577">
                        Not enough incentive to purchase the bundle
                      </p>
                    </div>
                  </div>
                  <div className="bg-white dark:bg-[#162825] p-5 rounded-lg border-2 border-[#2DB489] dark:border-[#4ED1A0]" data-id="element-4578">
                    <h4 className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-4579">
                      Optimal
                    </h4>
                    <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-4580">
                      15-30% discount
                    </p>
                    <div className="flex items-start" data-id="element-4581">
                      <CheckIcon className="h-5 w-5 text-green-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-4582" />
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD]" data-id="element-4583">
                        Attractive enough to motivate purchase while maintaining
                        value perception
                      </p>
                    </div>
                  </div>
                  <div className="bg-white dark:bg-[#162825] p-5 rounded-lg" data-id="element-4584">
                    <h4 className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-2" data-id="element-4585">
                      Too Large
                    </h4>
                    <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-4586">
                      50%+ discount
                    </p>
                    <div className="flex items-start" data-id="element-4587">
                      <XIcon className="h-5 w-5 text-red-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-4588" />
                      <p className="text-sm text-gray-600 dark:text-[#B0C1BD]" data-id="element-4589">
                        May devalue your products and train customers to wait
                        for deep discounts
                      </p>
                    </div>
                  </div>
                </div>
                <div className="bg-white dark:bg-[#162825] p-5 rounded-lg" data-id="element-4590">
                  <p className="font-medium text-gray-800 dark:text-[#F8FAF9] mb-3" data-id="element-4591">
                    Pricing Example:
                  </p>
                  <div className="space-y-3" data-id="element-4592">
                    <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-[#1A3330]" data-id="element-4593">
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-4594">
                        Website Template
                      </span>
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-4595">
                        $59
                      </span>
                    </div>
                    <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-[#1A3330]" data-id="element-4596">
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-4597">
                        Email Template
                      </span>
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-4598">
                        $29
                      </span>
                    </div>
                    <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-[#1A3330]" data-id="element-4599">
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-4600">
                        Social Media Pack
                      </span>
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-4601">
                        $39
                      </span>
                    </div>
                    <div className="flex items-center justify-between pb-2 border-b border-gray-100 dark:border-[#1A3330]" data-id="element-4602">
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-4603">
                        Individual Total
                      </span>
                      <span className="text-gray-700 dark:text-[#C4D1CC]" data-id="element-4604">
                        $127
                      </span>
                    </div>
                    <div className="flex items-center justify-between font-medium" data-id="element-4605">
                      <span className="text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-4606">
                        Bundle Price (20% off)
                      </span>
                      <span className="text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-4607">
                        $99
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="border-t border-gray-200 dark:border-[#1A3330] pt-10 mt-10" data-id="element-4608">
                <h2 className="text-2xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-6" data-id="element-4609">
                  Case Study: Successful Bundle Strategy
                </h2>
                <div className="bg-gray-50 dark:bg-[#1A3330] rounded-xl p-6 mb-8" data-id="element-4610">
                  <div className="flex items-center mb-4" data-id="element-4611">
                    <div className="w-12 h-12 rounded-full overflow-hidden mr-4" data-id="element-4612">
                      <img src="https://randomuser.me/api/portraits/men/41.jpg" alt="James Cooper" className="w-full h-full object-cover" data-id="element-4613" />
                    </div>
                    <div data-id="element-4614">
                      <h3 className="font-medium text-gray-800 dark:text-[#F8FAF9]" data-id="element-4615">
                        James Cooper
                      </h3>
                      <p className="text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-4616">
                        UI Kit Creator
                      </p>
                    </div>
                  </div>
                  <p className="text-gray-600 dark:text-[#B0C1BD] mb-4" data-id="element-4617">
                    "I had been selling individual UI component packs for
                    different purposes - dashboards, e-commerce, and mobile
                    apps. Each was priced at $49 and sold moderately well. After
                    analyzing my sales data, I noticed many customers would
                    eventually buy more than one pack."
                  </p>
                  <p className="text-gray-600 dark:text-[#B0C1BD] mb-4" data-id="element-4618">
                    "I decided to create a 'Complete UI System' bundle that
                    included all three packs plus a bonus style guide template.
                    I priced it at $119 (a 20% discount off buying separately).
                    Within the first month, the bundle became my best-selling
                    product, and my overall revenue increased by 35%."
                  </p>
                  <div className="mt-6 grid grid-cols-2 gap-4 text-center" data-id="element-4619">
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-4620">
                      <p className="text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-4621">
                        Before Bundling
                      </p>
                      <p className="text-xl font-bold text-gray-700 dark:text-[#C4D1CC]" data-id="element-4622">
                        $3,500/month
                      </p>
                    </div>
                    <div className="bg-white dark:bg-[#162825] p-4 rounded-lg" data-id="element-4623">
                      <p className="text-sm text-gray-500 dark:text-[#7A8F8A]" data-id="element-4624">
                        After Bundling
                      </p>
                      <p className="text-xl font-bold text-[#2DB489] dark:text-[#4ED1A0]" data-id="element-4625">
                        $4,725/month
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="bg-[#0D3C45]/5 dark:bg-[#0D3C45]/20 rounded-xl p-6 mt-12" data-id="element-4626">
                <h2 className="text-xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-4" data-id="element-4627">
                  Key Takeaways
                </h2>
                <ul className="space-y-3" data-id="element-4628">
                  <li className="flex items-start" data-id="element-4629">
                    <div className="bg-[#2DB489] dark:bg-[#4ED1A0] rounded-full p-1 mr-3 mt-1 flex-shrink-0" data-id="element-4630">
                      <CheckIcon className="h-3 w-3 text-white" data-id="element-4631" />
                    </div>
                    <p className="text-gray-700 dark:text-[#B0C1BD]" data-id="element-4632">
                      Bundle complementary products that solve a larger problem
                      for your customers
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-4633">
                    <div className="bg-[#2DB489] dark:bg-[#4ED1A0] rounded-full p-1 mr-3 mt-1 flex-shrink-0" data-id="element-4634">
                      <CheckIcon className="h-3 w-3 text-white" data-id="element-4635" />
                    </div>
                    <p className="text-gray-700 dark:text-[#B0C1BD]" data-id="element-4636">
                      Aim for a 15-30% discount to make bundles attractive while
                      maintaining value perception
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-4637">
                    <div className="bg-[#2DB489] dark:bg-[#4ED1A0] rounded-full p-1 mr-3 mt-1 flex-shrink-0" data-id="element-4638">
                      <CheckIcon className="h-3 w-3 text-white" data-id="element-4639" />
                    </div>
                    <p className="text-gray-700 dark:text-[#B0C1BD]" data-id="element-4640">
                      Create tiered bundles to appeal to different customer
                      segments and budgets
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-4641">
                    <div className="bg-[#2DB489] dark:bg-[#4ED1A0] rounded-full p-1 mr-3 mt-1 flex-shrink-0" data-id="element-4642">
                      <CheckIcon className="h-3 w-3 text-white" data-id="element-4643" />
                    </div>
                    <p className="text-gray-700 dark:text-[#B0C1BD]" data-id="element-4644">
                      Clearly communicate the value and savings of your bundle
                      compared to buying products individually
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            {/* Related resources */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm mb-10" data-id="element-4645">
              <h2 className="text-xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-6" data-id="element-4646">
                Related Resources
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4647">
                <a href="/learn/pricing-strategies" className="group block bg-gray-50 dark:bg-[#1A3330] rounded-lg p-5 transition-all hover:shadow-md" data-id="element-4648">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2 group-hover:text-[#2DB489] dark:group-hover:text-[#4ED1A0] transition-colors" data-id="element-4649">
                    Pricing Your Digital Products
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-4650">
                    Learn proven strategies for pricing your digital products to
                    maximize sales and revenue.
                  </p>
                  <div className="flex items-center text-[#2DB489] dark:text-[#4ED1A0] text-sm font-medium" data-id="element-4651">
                    <span data-id="element-4652">Read more</span>
                    <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-4653" />
                  </div>
                </a>
                <a href="/learn/limited-offers" className="group block bg-gray-50 dark:bg-[#1A3330] rounded-lg p-5 transition-all hover:shadow-md" data-id="element-4654">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2 group-hover:text-[#2DB489] dark:group-hover:text-[#4ED1A0] transition-colors" data-id="element-4655">
                    Creating Limited-Time Offers
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-4656">
                    Strategies for creating urgency and scarcity to boost sales
                    of your digital products.
                  </p>
                  <div className="flex items-center text-[#2DB489] dark:text-[#4ED1A0] text-sm font-medium" data-id="element-4657">
                    <span data-id="element-4658">Read more</span>
                    <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-4659" />
                  </div>
                </a>
              </div>
            </div>
            {/* CTA */}
            <div className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 text-white text-center" data-id="element-4660">
              <h2 className="text-2xl font-bold mb-4" data-id="element-4661">
                Ready to create your own product bundles?
              </h2>
              <p className="text-lg opacity-90 mb-6 max-w-2xl mx-auto" data-id="element-4662">
                Apply these bundle strategies to your digital products and start
                increasing your average order value today.
              </p>
              <a href="/sell-product" className="inline-block bg-white text-[#0D3C45] px-6 py-3 rounded-lg font-medium hover:bg-opacity-90 transition-all" data-id="element-4663">
                Start Selling
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-4664" />
    </div>;
};